export var SSR_ONLY = "ssrOnly";
export var WHEN_VISIBLE = "whenVisible";
export var WHEN_IDLE = "whenIdle";
export var ON = "on";
/**
 * @description Список стратегий для гидрации
 * @type { Array<string> }
 * * */

export var STRATEGY_WHITE_LIST = [SSR_ONLY, WHEN_VISIBLE, WHEN_IDLE, ON];